import { RequestUtil } from 'pmt-common';
import { setSurveyList, setSurveyCount } from './actions';

export const getSurveys = (page = 0, perPage = 10, search = '') =>
  async (dispatch) => {
    const params = new URLSearchParams({
      page: page.toString(),
      size: perPage.toString(),
      searchQuery: search,
    });

    try {
      const url = `/api/customForm/surveys?${params.toString()}`;
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include', // ensures cookies are sent
      });

      const response = await res.json();
      const totalSurveys = res.headers.get('X-Total-Count');
      // Normalize shape
      const surveys = Array.isArray(response)
        ? response
        : [];
      // Persist via thunk dispatch
      dispatch(setSurveyList(surveys));
      dispatch(setSurveyCount(totalSurveys));

    //   return surveys;
    } catch (err) {
      console.error('getSurveys failed:', err);
      throw err;
    }
  };

export const createOrUpdateSurvey = async (survey) => {
  try {
    const url = '/api/customForm/surveys/createOrUpdate';
    const data = survey;
    const response = await RequestUtil.postData(url, data);
    return response;
  } catch (err) {
    console.error('Failed to create survey: ', err);
    throw err;
  }
};

export const deleteSurvey = async (id) => {
  const url = `/api/customForm/surveys/${id}`;
  const response = await fetch(url, { method: 'DELETE' });
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch (err) {
    return text || null;
  }
};

export const getSurveyToRender = async (surveyId) => {
  const url = `/api/customForm/surveys/render/${surveyId}`;
  const response = await RequestUtil.getData(url);
  return response;
};

export const getSurveyVersions = async (surveyId) => {
  try {
    const url = `/api/customForm/surveys/history/${surveyId}`;
    const response = await RequestUtil.getData(url);
    return response;
  } catch (err) {
    console.error('getSurveyVersions failed:', err);
    throw err;
  }
};
